// =============================================================================
// FEEDBACK SERVICE - Сервіс для збору відгуків гравців
// =============================================================================

import { requireEnvUrl } from '../lib/env';

export interface FeedbackData {
  rating: number; // 1-5 зірок
  message: string;
  email?: string; // Контактний email для зворотного зв'язку
  gameResult: 'victory' | 'stalemate' | 'defeat' | 'gameOver';
  feedbackType?: 'feedback' | 'bug'; // Тип відгуку
  averageScore?: number;
  decisionNumber?: number;
  timestamp: string;
  userAgent?: string; // Для баг-репортів
}

/**
 * Надіслати відгук на API
 */
export async function submitFeedback(
  feedback: FeedbackData,
): Promise<{ success: boolean }> {
  const API_BASE_URL = requireEnvUrl('VITE_FEEDBACK_API_URL');

  try {
    const response = await fetch(`${API_BASE_URL}/feedbacks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...feedback,
        source: 'holovkom',
        type: feedback.feedbackType || 'feedback',
        email: feedback.email || undefined, // Include email if provided
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to submit feedback');
    }

    return { success: true };
  } catch (error) {
    console.error('Failed to submit feedback:', error);

    // Fallback: зберегти локально якщо API недоступний
    saveFeedbackLocally(feedback);

    return { success: true }; // Все одно показуємо успіх користувачу
  }
}

/**
 * Зберегти відгук локально як fallback
 */
function saveFeedbackLocally(feedback: FeedbackData): void {
  try {
    const stored = localStorage.getItem('holovkom_pending_feedback');
    const pending: FeedbackData[] = stored ? JSON.parse(stored) : [];
    pending.push(feedback);
    localStorage.setItem('holovkom_pending_feedback', JSON.stringify(pending));
  } catch {
    // ignore storage errors
  }
}

/**
 * Перевірити чи користувач вже залишав відгук
 */
export function hasSubmittedFeedback(): boolean {
  return localStorage.getItem('holovkom_feedback_submitted') === 'true';
}

/**
 * Позначити що відгук відправлено
 */
export function markFeedbackSubmitted(): void {
  localStorage.setItem('holovkom_feedback_submitted', 'true');
}

/**
 * Скинути статус відгуку (для нової гри при бажанні)
 */
export function resetFeedbackStatus(): void {
  localStorage.removeItem('holovkom_feedback_submitted');
}
